import { Product } from "typings";

export const getProductName = (product: Product) =>
{
    let itemName = product.id;
    if (product.data && product.data.itemName)
    {
        const keys = Object.keys(product.data.itemName.value);
        if (keys.length > 0)
        {
            itemName = product.data.itemName.value[keys[0]];
        }
    }
    return itemName;
};


// WEBPACK FOOTER //
// ./src/util/productHelper.ts